// import { TrackingClient } from '@sparefoot/tracking-client';
import { TrackingClient } from '@sparefoot/tracking-client';
import { omit } from 'lodash';
import { compose, withHandlers, mapProps } from 'recompose';

const withFormTracking = compose(
	withHandlers({
		handleSubmit: (props) => (evt) => {
			evt.stopPropagation();
			evt.preventDefault();

			const form = evt.target;
			const formData = new FormData(form);
			const trackingData = {
				form_id: form.id || props.id || form.className || '',
				form_target: form.action,
				form_url: form?.baseURI,
				email: formData.get('email') || undefined,
				first_name:
					formData.get('firstName') ||
					formData.get('alternateFirstNames') ||
					undefined,
				last_name:
					formData.get('lastName') ||
					formData.get('alternateLastNames') ||
					undefined,
			};

			TrackingClient && TrackingClient.trackFormSubmitted(trackingData);

			return Promise.resolve(props.onSubmit(evt));
		},
	}),
	mapProps((props) => ({
		...omit(props, [
			'handleSubmit',
			'invalid',
			'successLabel',
			'failureLabel',
		]),
		onSubmit: props.handleSubmit,
	})),
);

export default withFormTracking;
